// Version information reported to the analytics API so the panel can tell which
// build a device is running without logging into it.

// The Sentry vite plugin writes the deployed commit into window.SENTRY_RELEASE
// and the Sentry SDK uses the same value as the release.
declare global {
	interface Window {
		SENTRY_RELEASE?: { id?: string };
	}
}

/** Deployed bundle, i.e. the git commit of the release currently running. */
export const APP_VERSION = window.SENTRY_RELEASE?.id ?? "unknown";

const USER_AGENT = navigator.userAgent;

/** Installed Electron shell ("condorflix/1.1.3-patch.1"), or "browser" in a tab. */
export const APP_SHELL =
	USER_AGENT.match(/condorflix\/([^\s]+)/)?.[1] ?? "browser";

/** Electron runtime version, null in a plain browser. */
export const APP_RUNTIME = USER_AGENT.match(/Electron\/([^\s]+)/)?.[1] ?? null;
